import { render, staticRenderFns } from "./preferences.view.vue?vue&type=template&id=3146b91e&scoped=true&"
import script from "./preferences.view.ts?vue&type=script&lang=ts&"
export * from "./preferences.view.ts?vue&type=script&lang=ts&"
import style0 from "./preferences.view.scss?vue&type=style&index=0&id=3146b91e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3146b91e",
  null
  
)

export default component.exports